/**
*   以下两个方法是获取服务器时间相关
* */
export function getServerTime(){
  return new Promise((resolve,reject)=>{
    var xhr = new XMLHttpRequest();
    if( !xhr ){
      xhr = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xhr.open("HEAD",location.href,true);
    xhr.onreadystatechange=function(){
      if( xhr.readyState == 4 && xhr.status == 200 ){
        resolve(xhr.getResponseHeader("Date"));
        // return xhr.getResponseHeader("Date");
      }
    };
    xhr.send(null);
  })
};

export function dateTimeFormate(date){
  if(!date){
    return
  }else{
    var d = new Date(date);
    var year = d.getFullYear();
    var month = ('0' + (d.getMonth() + 1)).slice(-2);
    var day = ('0' + (d.getDate())).slice(-2);
    var hour = ('0' + (d.getHours())).slice(-2);
    var minutes = ('0' + (d.getMinutes())).slice(-2);
    var seconds = ('0' + (d.getSeconds())).slice(-2);
    return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    // return {y:year,m:month,d:day,h:hour};
  }
};

export function dateTimeFormate1(date){
  if(!date){
    return
  }else{
    var d = new Date(date);
    var month = ('0' + (d.getMonth() + 1)).slice(-2);
    var day = ('0' + (d.getDate())).slice(-2);
    return month + "-" + day + " ";
  }
};

export function randomsort(a, b) {
  return Math.random()>.5 ? -1 : 1;
  //用Math.random()函数生成0~1之间的随机数与0.5比较，返回-1或1
}
